(function () {
  function fill(select, n, v) {
    if (select.options.length !== n) {
      select.textContent = '';
      for (var k = 1; k <= n; k++) select.add(new Option(k, k));
    }
    select.value = Math.max(1, Math.min(v, n));
  }

  function field(select) {
    return select.parentNode.querySelector('input[name="quantity"]');
  }

  function picked(select) {
    var v = select.value;
    var pid = select.getAttribute('data-product');
    if (pid) {
      document.querySelectorAll('input[name="quantity"][data-product="' + pid + '"]').forEach(function (i) { i.value = v; });
      document.querySelectorAll('select[data-trm-qty][data-product="' + pid + '"]').forEach(function (s) { if (s !== select) s.value = v; });
    }
    var own = field(select);
    if (own) {
      own.value = v;
      own.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function variantChanged(id) {
    document.querySelectorAll('[data-trm-qty-map]').forEach(function (el) {
      var map = el._trmQty || (el._trmQty = JSON.parse(el.getAttribute('data-trm-qty-map')));
      var entry = map[id];
      if (!entry) return;
      if (el.tagName === 'SELECT') {
        var own = field(el);
        fill(el, entry[0], parseInt(own ? own.value : el.value, 10) || 1);
        if (own) own.value = el.value;
        el.parentNode.classList.toggle('trm-qty-off', entry[1] === 'out');
      } else {
        el.classList.toggle('trm-qty-off', entry[1] !== 'in');
      }
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;
    if (t.matches('select[data-trm-qty]')) picked(t);
    else if (t.matches('input[name="id"]')) {
      var id = t.value;
      setTimeout(function () { variantChanged(id); }, 0);
    }
  });
})();
